export const RESUME = "https://drive.google.com/uc?export=download&id=1x3F4ma3ToxABVCc-vJR0ZUSpv95Oug_8"

export const GITHUB = "https://github.com/devsmranjan"
export const LINKEDIN = "https://www.linkedin.com/in/devsmranjan"
export const HASHNODE = "https://smrutiranjanrana.hashnode.dev"
export const FACEBOOK = "https://www.facebook.com/devsmranjan"
export const TWITTER = "https://twitter.com/devsmranjan"